import { Grid } from "@material-ui/core/";
import CircularProgress from "@material-ui/core/CircularProgress";

const Spinner = () => {
  return (
    <Grid container direction="row" justifyContent="center" className="proGressP" alignItems="center">
      <CircularProgress />
    </Grid>
  );
};

export default Spinner;
